import { GLOBAL_CONSTANTS } from 'assets/js/utils/constants.js'

export default class NavHeight {
  constructor() {
    this.emitter = GLOBAL_CONSTANTS.UTILS.EMITTER
    this.isFirst = true

    this.init()
  }

  init() {
    this.emitter.on(GLOBAL_CONSTANTS.EVENTS.RESIZE, () => this.calculateHeight())
    this.emitter.on(GLOBAL_CONSTANTS.EVENTS.SCROLL, () => this.calculateVisibleHeight())

    const actionsSection = document.body.querySelector('.c-uhfh-actions')
    if (actionsSection) {
      const actionsObserver = new ResizeObserver(this.watchActionsResize.bind(this))
      actionsObserver.observe(document.body.querySelector('.c-uhfh-actions'))
    }

    this.isFirst = false

    this.calculateHeight()
  }

  updateCSSVars() {
    if (this.isFirst) {
      return
    }

    if (typeof this.wpHeight === 'number') {
      document.documentElement.style.setProperty('--wp-height', `${this.wpHeight}px`)
    }

    if (typeof this.uhfFullHeight === 'number') {
      document.documentElement.style.setProperty('--uhf-height', `${this.uhfFullHeight}px`)
    }

    if (typeof this.uhfHeight === 'number') {
      document.documentElement.style.setProperty('--uhftop-height', `${this.uhfHeight}px`)
    }

    if (typeof this.uhfFullHeight === 'number' || typeof this.wpHeight === 'number') {
      const uhfFullHeight = typeof this.uhfFullHeight === 'number' ? this.uhfFullHeight : 0
      const wpHeight = typeof this.wpHeight === 'number' ? this.wpHeight : 0
      document.documentElement.style.setProperty('--nav-height', `${uhfFullHeight + wpHeight}px`)
    }

    if (typeof this.interfaceHeaderHeight === 'number' || typeof this.interfaceFooterHeight === 'number') {
      const interfaceHeaderHeight = typeof this.interfaceHeaderHeight === 'number' ? this.interfaceHeaderHeight : 0
      const interfaceFooterHeight = typeof this.interfaceFooterHeight === 'number' ? this.interfaceFooterHeight : 0
      document.documentElement.style.setProperty('--editor-height', `${interfaceHeaderHeight + interfaceFooterHeight}px`)
    }

    if (typeof this.documentWidth === 'number' && typeof this.actionsSectionLeft === 'number') {
      document.documentElement.style.setProperty('--uhf-actions-right-inset', `${this.documentWidth - this.actionsSectionLeft}px`)
    }

    if (typeof this.wpHeight === 'number' && typeof this.scrollY === 'number' && typeof this.wpHeight === 'number') {
      document.documentElement.style.setProperty('--nav-height-visible', `${Math.max(0, this.uhfFullHeight - this.scrollY) + this.wpHeight}px`)
    }
  }

  calculateHeight() {
    const uhf = document.body.querySelector('#headerArea')
    const uhfFull = document.body.querySelector('#site-header')
    const wp = document.body.querySelector('#wpadminbar')
    const interfaceHeader = document.body.querySelector('.interface-interface-skeleton__header')
    const interfaceFooter = document.body.querySelector('.interface-interface-skeleton__footer')

    if (document.body.classList.contains('microsoft-uhf')) {
      this.uhfHeight = uhf ? uhf.offsetHeight : null
      this.uhfFullHeight = uhfFull ? uhfFull.offsetHeight : null
    }
    this.wpHeight = wp ? wp.offsetHeight : null
    this.interfaceHeaderHeight = interfaceHeader ? interfaceHeader.offsetHeight : null
    this.interfaceFooterHeight = interfaceFooter ? interfaceFooter.offsetHeight : null
    this.documentWidth = document.documentElement.clientWidth

    const actionsSection = document.body.querySelector('.c-uhfh-actions')
    if (actionsSection) {
      this.actionsSectionLeft = actionsSection.getBoundingClientRect().left
    }

    this.updateCSSVars()
  }

  calculateVisibleHeight() {
    this.scrollY = Math.max(0, document.documentElement.scrollTop || document.body.scrollTop)

    this.updateCSSVars()
  }

  watchActionsResize(entries) {
    for (const entry of entries) {
      this.actionsSectionLeft = entry.target.getBoundingClientRect().left
    }
    this.updateCSSVars()
  }
}
